import {CurrencyEuroIcon} from "@heroicons/react/24/outline";

export const buildPaymentStats = (monthPayment,
                                  totalOutstanding,
                                  top5SharePercent,
                                  performanceNote,
                                  performanceColor,
                                  paymentRequestsLoading,
                                  hasPaymentSubmitted) => [
  {
    title: 'Month Payment',
    count: `€${monthPayment.toFixed(2)}`,
    note: 'Sum of current payments',
    icon: CurrencyEuroIcon,
    textColor: 'text-brand-800',
    badge: paymentRequestsLoading
      ? "Checking payment submission..."
      : hasPaymentSubmitted
        ? "Payment submitted"
        : "Payment not yet submitted",
    badgeColor: paymentRequestsLoading
      ? "bg-gray-100 text-gray-500"
      : hasPaymentSubmitted
        ? "bg-green-100 text-green-800"
        : "bg-yellow-100 text-yellow-800",
  },
  {
    title: 'Outstanding',
    count: `€${totalOutstanding.toFixed(2)}`,
    note: "Total amount outstanding from previous month",
    icon: CurrencyEuroIcon,
    textColor: 'text-yellow-800',
  },
  {
    title: 'Top 5 Reward',
    count: `${top5SharePercent.toFixed(2)}%`,
    note: performanceNote,
    icon: CurrencyEuroIcon,
    textColor: performanceColor
  },
];